import * as React from "react";

import { IProcessVariable } from "../../../processEditor/model/IProcessData";

export const DeployDialogProcessVariableDisplay: React.FC<DeployDialogProcessVariableDisplay> = (props) => {
    const [isMasked, setIsMasked] = React.useState(props.processVariable.isSecret);

    return <><b>{props.processVariable.name}</b> &#8211; {props.processVariable.isSecret
        ? <span onClick={() => setIsMasked(!isMasked)} style={{ cursor: "pointer" }}>
            {isMasked ? <span aria-hidden="true">{"*".repeat(props.processVariable.value.length)}</span> : props.processVariable.value} <i className="ci-hide" />
        </span>
        : props.processVariable.value}</>
};

interface DeployDialogProcessVariableDisplay {
    processVariable: IProcessVariable;
}